import React from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'antd-v4'

interface Props {
  label: string
  viewAction: () => void
  printAction: () => void
}

const ParkedSaleViewPrintButtonsComponent = ({ label, viewAction, printAction }: Props) => {
  return (
    <div className='parked-sales-modal-field-content parked-sales-receipt'>
      <p style={{ marginRight: label === 'Receipt' ? '70px' : '40px' }}>{label}</p>
      <div>
        <Button type='link' className='parked-sales-receipt-button' onClick={viewAction}>
          View
        </Button>
        <p>|</p>
        <Button type='link' className='parked-sales-receipt-button' onClick={printAction}>
          Print
        </Button>
      </div>
    </div>
  )
}

export const ParkedSaleViewPrintButtons = observer(ParkedSaleViewPrintButtonsComponent)
